<template>
  <!-- page meta -->
  <div>
    <Head>
      <title>Platforma | Terms & Conditions</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Create a private membership site platform to monetize your content."
      />
    </Head>
  </div>
  <!-- content -->
  <div
    class="min-[1140px]:max-w-[1200px] container relative mx-auto bg-transparent"
  >
    <!-- heading & toggler -->
    <section
      id="section1"
      class="hero-section relative mx-auto mt-[115px] justify-center gap-1 bg-transparent flex lg:py-0"
      :style="backgroundImageStyleMain"
    >
      <div class="mt-0 bg-transparent px-[25px] xl:px-0 z-10">
        <!-- heading -->
        <div>
          <h1
            class="top-full mt-0 text-center px-0 text-[35px] font-extrabold tracking-normal text-[#fff] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
          >
            Terms and Conditions
          </h1>
          <!-- terms -->
          <div class="pt-32 px-2">
            <h3 class="text-xl">PRIVACY STATEMENT</h3>
            <span class="text-gray-600">Last Updated: 02/22/2023 </span>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p class="pt-4">
                WELCOME TO PLATFORM. WE LOOK FORWARD TO HELPING YOU ELEVATE YOUR
                ONLINE BUSINESS TO THE NEXT LEVEL.
              </p>
              <p>
                THIS AGREEMENT SETS FORTH YOUR RIGHTS AND OBLIGATIONS AS A
                PLATFORM USER. BY SIGNING UP FOR PLATFORM, YOU INDICATE THAT YOU
                HAVE READ AND UNDERSTOOD THIS AGREEMENT AND YOU WILL BE BOUND BY
                ITS TERMS.
              </p>
            </div>
            <h3 class="text-xl pt-8">I. DEFINITIONS</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                A. “PLATFORM” IS A TRADEMARK OF PLATFORM APPLICATION, INC.
                <br />
                B. “PARTIES” MEAN PLATFORM APPLICATION, INC. AND YOU. PLATFORM
                APPLICATION, INC. AND YOU ARE EACH A “PARTY.” <br />
                C. “TERMS” MEAN AND REFER TO THE TERMS AND CONDITIONS SET FORTH
                HEREIN. <br />
                D. “USER” REFERS TO A PERSON WHO HAS CREATED A PLATFORM ACCOUNT.
                “USER ACCOUNT” REFERS TO A USER’S PLATFORM ACCOUNT. <br />
                E. “YOU” AND “YOUR” MEANS THE PLATFORM USER WHO HAS EXECUTED
                THIS AGREEMENT BY SIGNING UP “I AGREE.”
              </p>
            </div>
            <h3 class="text-xl pt-8">II. BECOMING A PLATFORM USER</h3>

            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                BY CLICKING “SIGN-UP” TO THESE TERMS, TRANSFERRING PAYMENT TO
                PLATFORM, AND CREATING A USER ACCOUNT, YOU BECOME A PLATFORM
                USER. THERE ARE VARIOUS PRODUCTS AND SERVICES AVAILABLE TO
                USERS, AND MONTHLY PRICES APPLICABLE TO SUCH PRODUCTS AND
                SERVICES. PLATFORM PRODUCTS, SERVICES, AND PRICES ARE SUBJECT TO
                CHANGE WITHOUT NOTICE. PRICE CHANGES ARE EFFECTIVE ON THE FIRST
                DAY OF THE MONTH. , BY “SIGNING UP” AND PROVIDING PLATFORM YOUR
                CREDIT CARD INFORMATION YOU AUTHORIZE PLATFORM TO CHARGE YOUR
                CREDIT CARD IN THE AMOUNT INDICATED FOR THE VALUE OF THE
                SERVICES YOU SELECT, INCLUDING ANY FUTURE PRICE CHANGES. BY YOUR
                CONTINUED USE OF PLATFORM SERVICES, AND UNLESS YOU TERMINATE
                THIS AGREEMENT AS PROVIDED HEREIN, YOU AGREE THAT PLATFORM MAY
                CHARGE YOUR CREDIT CARD MONTHLY FOR THE PRODUCTS AND SERVICES
                YOU HAVE SELECTED, AND YOU CONSENT TO ANY PRICE CHANGES FOR SUCH
                SERVICES.
              </p>
            </div>
            <h3 class="text-xl pt-8">III. TERM AND TERMINATION</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                YOUR USER CONTRACT WITH PLATFORM BEGINS WHEN YOU SIGN-UP AND
                WILL CONTINUE UNTIL EITHER: <br />A. PLATFORM CANCELS YOUR
                ACCOUNT DUE TO YOUR BREACH OF ANY OF THE TERMS OF THIS
                AGREEMENT. IN THE EVENT THIS AGREEMENT IS CANCELLED DUE TO YOUR
                BREACH, YOU WILL NOT BE ENTITLED TO PRO-RATE YOUR LAST MONTH’S
                USE, NOR WILL YOU BE ENTITLED TO ANY REFUND FOR ANY PAYMENTS YOU
                HAVE MADE TO PLATFORM. <br />OR <br />B. YOU PROVIDE PLATFORM A
                TEN (10) DAYS’ E-MAIL NOTICE, AS PROVIDED HEREIN, OF YOUR
                CANCELLATION OF YOUR ACCOUNT. IF YOU PROVIDE SUCH NOTICE LESS
                THAN TEN (10) DAYS BEFORE THE FIRST DAY OF THE NEXT MONTH, YOUR
                CREDIT CARD MAY STILL BE CHARGED. YOU WILL NOT BE ENTITLED TO
                PRO-RATE YOUR LAST MONTH’S USE, NOR WILL YOU BE ENTITLED TO ANY
                REFUND FOR ANY PAYMENTS TO PLATFORM. <br />OR <br />C.YOUR
                CREDIT CARD OR PLATFORM’S CHARGE IS DENIED FOR ANY REASON AND
                YOU DO NOT PROVIDE PLATFORM A NEW CREDIT CARD WITHIN TEN (10)
                DAYS.
              </p>
            </div>
            <h3 class="text-xl pt-8">IV. REFUNDS FOR “HARD GOODS”</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                IF YOU HAVE PURCHASED A “HARD GOOD” (FOR EXAMPLE, A BOOK, MP3
                PLAYER, OR OTHER TANGIBLE PRODUCT) FROM PLATFORM SOLD UNDER ANY
                OF ITS BRANDS OR RELATED BRANDS, INCLUDING WITHOUT LIMITATION
                PLATOFORM, YOU MAY RECEIVE A LIMITED REFUND IF YOU COMPLY WITH
                THE FOLLOWING CONDITIONS: <br />1. YOU MUST REQUEST A REFUND IN
                WRITING BY CONTACTING INFO@PLATFORMAREA.COM; <br />2. YOUR
                REQUEST FOR A REFUND MUST BE MADE WITHIN FOURTEEN (14) DAYS OF
                YOUR PURCHASE; <br />3. YOU MUST RETURN THE HARD GOODS TO
                PLATFORM IMMEDIATELY, ACCORDING TO THE SHIPPING AND OTHER
                INSTRUCTIONS YOU WILL RECEIVE BY EMAIL AFTER REQUESTING A
                REFUND; <br />4. THE HARD GOODS MUST BE RETURNED TO PLATFORM IN
                LIKE-NEW, OR RE-SELLABLE CONDITION, AS DETERMINED IN PLATFORM
                SOLE, REASONABLE DISCRETION.
              </p>
            </div>
            <h3 class="text-xl pt-8">V. NO LICENSE TO USE PLATFORM MARKS</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                ANY CONTENT ON ANY PLATFORM WEBSITE MAY CONSTITUTE THE
                INTELLECTUAL PROPERTY OF PLATFORM. EXCEPT WHERE EXPRESSLY
                AUTHORIZED, NO MATERIAL ON ANY PLATFORM WEBSITE MAY BE COPIED,
                REPRODUCED, DISTRIBUTED, REPUBLISHED, UPLOADED, DISPLAYED,
                POSTED OR TRANSMITTED IN ANY WAY WHATSOEVER. THE PLATFORM
                TRADEMARK AND LOGO ARE PROPRIETARY MARKS OF PLATFORM, AND THE
                USE OF THOSE MARKS IS STRICTLY PROHIBITED. NOTHING HEREIN GIVES
                YOU THE RIGHT TO USE, COPY, REGISTER AS A DOMAIN NAME,
                REPRODUCE, OR OTHERWISE DISPLAY ANY LOGO, TAGLINE, TRADEMARK,
                TRADE NAME, COPYRIGHTED MATERIAL, PATENT, TRADE DRESS, TRADE
                SECRET, OR CONFIDENTIAL INFORMATION OWNED BY PLATFORM OR ANY OF
                PLATFORMS’ AFFILIATES.
              </p>
            </div>
            <h3 class="text-xl pt-8">VI. INDEMNITY.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                YOU AGREE TO PROTECT, DEFEND, INDEMNIFY AND HOLD HARMLESS
                PLATFORM, ITS OFFICERS, DIRECTORS, EMPLOYEES, OWNER(S), AND
                PARENT COMPANY(IES) AND ASSIGNS FROM AND AGAINST ALL CLAIMS,
                DEMANDS, AND CAUSES OF ACTION OF EVERY KIND AND CHARACTER
                WITHOUT LIMIT ARISING OUT OF YOUR CONDUCT. YOUR INDEMNITY
                OBLIGATION INCLUDES, BUT IS NOT LIMITED TO, ANY THIRD PARTY
                CLAIM AGAINST FORMULA SECRETS FOR LIABILITY FOR PAYMENTS FOR,
                DAMAGES CAUSED BY, OR OTHER LIABILITY RELATING TO, YOU.
              </p>
            </div>
            <h3 class="text-xl pt-8">VII. NO WARRANTY; NO LEADS.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                PLATFORM DOES NOT PROMISE, GUARANTEE OR WARRANT YOUR IMAGE
                SUCCESS, INCOME, OR SALES. YOU UNDERSTAND AND ACKNOWLEDGE THAT
                PLATFORM WILL NOT AT ANY TIME PROVIDE SALES LEADS OR REFERRALS
                TO YOU. ADDITIONALLY, PLATFORMS’ WEBSITES AND SERVICES ARE
                PROVIDED “AS IS” WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR
                IMPLIED, INCLUDING WITHOUT LIMITATION IMPLIED WARRANTIES OF
                TITLE, MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
                NONINFRINGEMENT. PLATFORM MAKES NO REPRESENTATION OR WARRANTY AS
                TO THE ACCURACY, RELIABILITY, TIMELINESS OR COMPLETENESS OF ANY
                MATERIAL ON OR ACCESSIBLE THROUGH ANY PLATFORM APPLICATION, INC
                WEBSITE OR SERVICE. ANY RELIANCE ON OR USE OF SUCH MATERIALS
                SHALL BE AT YOUR SOLE RISK. PLATFORM MAKES NO REPRESENTATION OR
                WARRANTY (A) THAT ANY PLATFORM WEBSITE OR SERVICE WILL BE
                AVAILABLE ON A TIMELY BASIS, OR THAT ACCESS TO ANY PLATFORM
                WEBSITE OR SERVICE WILL BE UNINTERRUPTED, ERROR-FREE OR SECURE;
                (B) THAT DEFECTS OR ERRORS WILL BE CORRECTED; OR (C) THAT ANY
                PLATFORM WEBSITE OR THE SERVERS OR NETWORKS THROUGH WHICH ANY
                PLATFORM WEBSITE IS MADE AVAILABLE ARE SECURE OR FREE OF VIRUSES
                OR OTHER HARMFUL COMPONENTS. APPLICABLE LAW MAY NOT ALLOW THE
                EXCLUSION OF IMPLIED WARRANTIES, SO THE ABOVE EXCLUSION MAY NOT
                APPLY TO YOU. THE PLATFORM WEBSITES MAY INCLUDE INACCURACIES,
                ERRORS AND MATERIALS THAT CONFLICT WITH THESE TERMS. IN THE
                EVENT OF ANY CONFLICT BETWEEN ANYTHING POSTED ON ANY PLATFORM
                WEBSITE AND THESE TERMS, THESE TERMS SHALL CONTROL.
              </p>
            </div>
            <h3 class="text-xl pt-8">VIII. LIMITATION OF LIABILITY.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                YOU AGREE THAT IN NO EVENT SHALL PLATFORM’S LIABILITY TO YOU FOR
                ANY CLAIM OF ANY KIND OR DESCRIPTION EXCEED THE AMOUNT OF THREE
                (3) TIMES THE PAYMENTS PAID BY YOU TO PLATFORM FOR THE MONTH
                PRECEDING THE DATE IN WHICH THE FACTS GIVING RISE TO A CLAIM
                AGAINST PLATFORM OCCURRED. YOU WAIVE ANY RIGHT TO SPECIAL,
                INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND OR DESCRIPTION.
              </p>
            </div>
            <h3 class="text-xl pt-8">IX. FORCE MAJEURE.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                PLATFORM WILL NOT BE RESPONSIBLE TO YOU FOR ANY DELAY, DAMAGE,
                OR FAILURE CAUSED BY OR OCCASIONED BY A FORCE MAJEURE EVENT. AS
                USED IN THIS AGREEMENT, “FORCE MAJEURE EVENT” SHALL MEAN: ANY
                ACT OF GOD, ACT OF NATURE OR THE ELEMENTS, TERRORISM,
                INSURRECTION, REVOLUTION OR CIVIL STRIFE, PIRACY, CIVIL WAR OR
                HOSTILE ACTION, LABOR STRIKES, ACTS OF PUBLIC ENEMIES, FEDERAL
                OR STATE LAWS, RULES AND REGULATIONS OF ANY GOVERNMENTAL
                AUTHORITIES HAVING JURISDICTION OVER THE PREMISES, INABILITY TO
                PROCURE MATERIAL, EQUIPMENT, OR NECESSARY LABOR IN THE OPEN
                MARKET, ACUTE AND UNUSUAL LABOR, MATERIAL, OR EQUIPMENT
                SHORTAGES, OR ANY OTHER CAUSES BEYOND THE CONTROL OF PLATFORM.
                DELAYS DUE TO ANY OF THE ABOVE CAUSES SHALL NOT BE DEEMED TO BE
                A BREACH OF OR FAILURE TO PERFORM UNDER THIS AGREEMENT. PLATFORM
                APPLICATION, INC. SHALL NOT BE REQUIRED AGAINST ITS WILL TO
                ADJUST ANY LABOR OR OTHER SIMILAR DISPUTE EXCEPT IN ACCORDANCE
                WITH APPLICABLE LAW.
              </p>
            </div>
            <h3 class="text-xl pt-8">X. ASSIGNMENT OF RIGHTS.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                PLATFORM APPLICATION, INC. MAY ASSIGN ITS RIGHTS UNDER THIS
                AGREEMENT AT ANY TIME, WITHOUT NOTICE TO YOU. YOUR RIGHTS
                ARISING UNDER THIS AGREEMENT CANNOT BE ASSIGNED BY WITHOUT
                PLATFORM APPLICATION, INC.’S OR ITS ASSIGNS EXPRESS WRITTEN
                CONSENT.
              </p>
            </div>
            <h3 class="text-xl pt-8">
              XI. INFORMATION; REGISTRATION; USER NAMES AND PASSWORDS
            </h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                AS A PLATFORM USER, YOU WILL BE REQUIRED TO CREATE AN ACCOUNT
                WITH PLATFORM. YOU WARRANT THAT THE INFORMATION YOU PROVIDE US
                IS TRUTHFUL AND ACCURATE, AND THAT YOU ARE NOT IMPERSONATING
                ANOTHER PERSON. YOU ARE RESPONSIBLE FOR MAINTAINING THE
                CONFIDENTIALITY OF ANY PASSWORD YOU MAY USE TO ACCESS YOUR
                PLATFORM USER ACCOUNT, AND YOU AGREE NOT TO TRANSFER YOUR
                PASSWORD OR USER NAME, OR LEND OR OTHERWISE TRANSFER YOUR USE OF
                OR ACCESS TO YOUR USER ACCOUNT, TO ANY THIRD PARTY. YOU ARE
                FULLY RESPONSIBLE FOR ALL TRANSACTIONS WITH, AND INFORMATION
                CONVEYED TO, PLATFORM UNDER YOUR USER ACCOUNT. YOU AGREE TO
                IMMEDIATELY NOTIFY PLATFORM OF ANY UNAUTHORIZED USE OF YOUR
                PASSWORD OR USER NAME OR ANY OTHER BREACH OF SECURITY RELATED TO
                YOUR USER ACCOUNT. YOU AGREE THAT PLATFORM IS NOT LIABLE, AND
                YOU WILL HOLD PLATFORM HARMLESS, FOR ANY LOSS OR DAMAGE ARISING
                FROM YOUR FAILURE TO COMPLY WITH ANY OF THE FOREGOING
                OBLIGATIONS.
              </p>
            </div>
            <h3 class="text-xl pt-8">
              XII. RELEASE/AUTHORIZATION TO USE PHOTOGRAPHS.
            </h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                YOU GRANT PLATFORM PERMISSION TO USE ANY AND ALL PHOTOGRAPHS
                TAKEN BY PLATFORM OR ITS AGENTS OR EMPLOYEES, OR SUBMITTED BY
                YOU TO PLATFORM (HEREINAFTER “PHOTOGRAPHS”) IN ANY MEDIA
                (INCLUDING PRINT, INTERNET, FILM, TELEVISION AND NO MATTER HOW
                DISTRIBUTED OR PUBLISHED) FOR ANY PURPOSE, WHICH MAY INCLUDE,
                BUT SHALL NOT BE LIMITED TO, ADVERTISING, PROMOTION, MARKETING
                AND PACKAGING OF PLATFORM OR ANY PRODUCT OR SERVICE SOLD AND
                MARKETED BY PLATFORM APPLICATION, INC. YOU AGREE THAT THIS
                AUTHORIZATION TO USE PHOTOGRAPHS MAY BE ASSIGNED BY PLATFORM
                APPLICATION, INC. TO ANY OTHER PARTY. YOU AGREE THAT THAT THE
                PHOTOGRAPHS MAY BE COMBINED WITH OTHER PHOTOGRAPHS, SOUNDS, TEXT
                AND GRAPHICS, AND THAT THE PHOTOGRAPHS MAY BE MANIPULATED,
                CROPPED, ALTERED OR MODIFIED IN PLATFORM APPLICATION, INC.'S
                SOLE DISCRETION. YOU AGREE NOT TO CHARGE A ROYALTY OR FEE, AND
                NOT TO MAKE ANY OTHER MONETARY ASSESSMENT AGAINST PLATFORM
                APPLICATION, INC. IN EXCHANGE FOR THIS RELEASE AND ASSIGNMENT.
                YOU HEREBY RELEASE AND FOREVER DISCHARGE PLATFORM APPLICATION,
                INC. FROM ANY AND ALL LIABILITY AND FROM ANY DAMAGES YOU MAY
                SUFFER AS A RESULT OF THE USE OF THE PHOTOGRAPHS. YOU FURTHER
                ACKNOWLEDGE AND AGREE THAT THIS RELEASE IS BINDING UPON YOUR
                HEIRS AND ASSIGNS. YOU AGREE THAT THIS RELEASE IS IRREVOCABLE.
              </p>
            </div>
            <h3 class="text-xl pt-8">XIII. PROHIBITED ACTIVITY.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                PLATFORM HAS THE RIGHT TO TERMINATE THIS AGREEMENT AT ANY TIME
                IF YOU ENGAGE OR HAVE EVER ENGAGED IN ANY OF THE FOLLOWING:
                <br />A. HARMFUL ACTS. ANY DISHONEST OR UNETHICAL BUSINESS
                PRACTICE; ANY VIOLATION OF THE LAW; INFLICTION OF HARM TO
                PLATFORM’ REPUTATION; AND THE VIOLATION OF THE RIGHTS OF
                PLATFORM OR ANY THIRD PARTY. <br />B. “SPAMMING” AND UNSOLICITED
                COMMUNICATIONS. WE HAVE ZERO TOLERANCE FOR UCE/SPAM. ANY
                COMMUNICATIONS SENT OR AUTHORIZED BY YOU REASONABLY DEEMED
                “SPAMMING,” OR ANY OTHER UNSOLICITED SOLICITATIONS (INCLUDING
                WITHOUT LIMITATION POSTINGS ON SOCIAL MEDIA OR THIRD PARTY
                BLOGS) WILL BE DEEMED A MATERIAL THREAT TO PLATFORMS’ REPUTATION
                AND TO THE RIGHTS OF THIRD PARTIES. IT IS YOUR OBLIGATION,
                EXCLUSIVELY, TO ENSURE THAT ALL BUSINESS COMMUNICATIONS COMPLY
                WITH STATE AND LOCAL ANTI-SPAMMING OR ANALOGOUS LAWS.
              </p>
            </div>
            <h3 class="text-xl pt-8">
              XIV. MESSAGE SENDING POLICY AND BEST PRACTICES.
            </h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                PLATFORM APPLICATION, INC. REQUIRES YOU TO FOLLOW THESE BEST
                PRACTICES WHEN SENDING ELECTRONIC COMMUNICATIONS USING OUR
                SERVICES: <br />USE ONLY PERMISSION-BASED MARKETING ELECTRONIC
                COMMUNICATIONS LISTS (I.E., LISTS IN WHICH EACH RECIPIENT
                AFFIRMATIVELY OPTED-IN TO RECEIVING THOSE ELECTRONIC
                COMMUNICATIONS). ALWAYS INCLUDE A WORKING “UNSUBSCRIBE”
                MECHANISM IN EACH MARKETING ELECTRONIC COMMUNICATION THAT ALLOWS
                THE RECIPIENT TO OPT OUT FROM YOUR MAILING LIST
                (RECEIPT/TRANSACTIONAL MESSAGES THAT ARE EXEMPT FROM
                “UNSUBSCRIBE” REQUIREMENTS OF APPLICABLE LAW ARE EXEMPT FROM
                THIS REQUIREMENT). <br />COMPLY WITH ALL REQUESTS FROM
                RECIPIENTS TO BE REMOVED FROM YOUR MAILING LIST WITHIN THE
                EARLIER OF 10 DAYS OF RECEIPT OF THE REQUEST, OR THE DEADLINE
                UNDER APPLICABLE LAW. MAINTAIN, PUBLISH, AND COMPLY WITH A
                PRIVACY POLICY THAT MEETS ALL APPLICABLE LEGAL REQUIREMENTS,
                WHETHER OR NOT YOU CONTROL THE SENDING OF THE ELECTRONIC
                COMMUNICATIONS, AND INCLUDE A LINK TO SUCH PRIVACY POLICY IN
                YOUR ELECTRONIC COMMUNICATIONS.. INCLUDE IN EACH ELECTRONIC
                COMMUNICATIONS A LINK TO YOUR THEN-CURRENT PRIVACY POLICY
                APPLICABLE TO THAT ELECTRONIC COMMUNICATION. INCLUDE IN EACH
                ELECTRONIC COMMUNICATION YOUR VALID PHYSICAL MAILING ADDRESS OR
                A LINK TO THAT INFORMATION. <br />DO NOT SEND ELECTRONIC
                COMMUNICATIONS TO ADDRESSES OBTAINED FROM PURCHASED OR RENTED
                LISTS. DO NOT USE THIRD PARTY ELECTRONIC ADDRESSES, DOMAIN
                NAMES, OR MAIL SERVERS WITHOUT PROPER PERMISSION FROM THE THIRD
                PARTY. DO NOT ROUTINELY SEND ELECTRONIC COMMUNICATIONS TO
                NON-SPECIFIC ADDRESSES (E.G., WEBMASTER@DOMAIN.COM OR
                INFO@DOMAIN.COM). DO NOT SEND ELECTRONIC COMMUNICATIONS THAT
                RESULT IN AN UNACCEPTABLE NUMBER OF SPAM OR SIMILAR COMPLAINTS
                (EVEN IF THE ELECTRONIC COMMUNICATIONS THEMSELVES ARE NOT
                ACTUALLY SPAM). DO NOT DISGUISE THE ORIGIN, OR SUBJECT MATTER
                OF, ANY ELECTRONIC COMMUNICATIONS OR FALSIFY OR MANIPULATE THE
                ORIGINATING MESSAGE ADDRESS, SUBJECT LINE, HEADER, OR
                TRANSMISSION PATH INFORMATION FOR ANY ELECTRONIC COMMUNICATION.
                DO NOT SEND OFFERS TO OBTAIN OR ATTEMPT TO OBTAIN PERSONAL
                INFORMATION, OR GENERATE LEADS, FOR THIRD PARTIES. DO NOT SEND
                “CHAIN LETTERS,” “PYRAMID SCHEMES,” OR OTHER TYPES OF ELECTRONIC
                MESSAGES THAT ENCOURAGE THE RECIPIENT TO FORWARD THE CONTENT TO
                STRANGERS. DO NOT SEND TO LISTS OF ADDRESSES THAT ARE
                PROGRAMMATICALLY GENERATED OR SCRAPED FROM THE WEB. DO NOT
                EMPLOY SENDING PRACTICES, OR HAVE OVERALL MESSAGE DELIVERY
                RATES, WHICH NEGATIVE IMPACT OUR SERVICES OR OTHER USERS OF OUR
                SERVICES. DO NOT USE OUR SERVICES TO SEND MESSAGES THAT MAY BE
                CONSIDERED JUNK MAIL. SOME EXAMPLES OF THIS TYPE OF MESSAGES
                INCLUDE MESSAGING RELATED TO: PENNY STOCKS, GAMBLING,
                MULTI-LEVEL MARKETING, DIRECT TO CONSUMER PHARMACEUTICAL SALES,
                PAYDAY LOANS, ETC. COMPLIANCE WITH LAW. YOUR USE OF OUR SERVICES
                MUST COMPLY WITH ALL APPLICABLE LAWS, RULES, REGULATIONS, AND
                COURT ORDERS OF ANY KIND OF ANY JURISDICTION APPLICABLE TO YOU,
                US, AND ANY RECIPIENT TO WHOM YOU USE OUR SERVICES TO SEND
                DIGITAL MESSAGES (“APPLICABLE LAW”). YOU HAVE THE RESPONSIBILITY
                TO BE AWARE OF AND UNDERSTAND ALL APPLICABLE LAWS AND ENSURE
                THAT YOU AND ALL USERS OF YOUR ACCOUNT COMPLY AT ALL TIMES WITH
                APPLICABLE LAW. SOME EXAMPLES OF APPLICABLE LAWS INCLUDE: THE
                U.S. CAN-SPAM ACT, THE E.U. DIRECTIVE OF PRIVACY AND ELECTRONIC
                COMMUNICATIONS, THE U.K. PRIVACY AND ELECTRONIC COMMUNICATIONS
                (EC DIRECTIVE) REGULATIONS 2003; THE CANADA ANTI-SPAM LAW (CASL)
                AND/OR ANY SIMILAR LAW, LAWS RELATING TO INTELLECTUAL PROPERTY,
                PRIVACY, SECURITY, TERRORISM, CORRUPTION, CHILD PROTECTION, OR
                IMPORT/EXPORT LAWS. <br />YOU MUST NOT USE OUR SERVICES TO:
                STORE, DISTRIBUTE OR TRANSMIT ANY MALWARE OR OTHER MATERIAL THAT
                YOU KNOW WILL DESTROY OR EFFECT OTHER DIGITAL INFASTRUCTURES
                SENSITIVE INFORMATION. YOU WILL NOT IMPORT, OR INCORPORATE INTO,
                ANY CONTACT LISTS OR OTHER CONTENT YOU UPLOAD TO ANY WEBSITE,
                SOFTWARE, OR OTHER ELECTRONIC SERVICE HOSTED OR PROVIDED BY
                PLATFORM APPLICATION, INC., ANY OF THE FOLLOWING INFORMATION:
                SOCIAL SECURITY NUMBERS, NATIONAL INSURANCE NUMBERS, CREDIT CARD
                DATA, PASSWORDS, SECURITY CREDENTIALS, BANK ACCOUNT NUMBERS, OR
                SENSITIVE PERSONAL, HEALTH OR FINANCIAL INFORMATION OF ANY KIND.
              </p>
            </div>
            <h3 class="text-xl pt-8">XV. CONTACT</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                IF YOU HAVE ANY QUESTIONS OR COMPLAINTS CONCERNING ANY OF THE
                TERMS, YOU MAY CONTACT PLATFORM APPLICATION, INC. BY E-MAIL AT
                INFO[A]PLATFORMAREA.COM, OR BY REGULAR MAIL AT 340 ROYAL
                POINCIANA WAY, STE.317-316, PALM BEACH, FLORIDA 33480.
                CALIFORNIA RESIDENTS, UNDER CALIFORNIA CIVIL CODE SECTION
                1789.3, MAY ALSO REACH THE COMPLAINT ASSISTANCE UNIT OF THE
                DIVISION OF CONSUMER SERVICES OF THE CALIFORNIA DEPARTMENT OF
                CONSUMER AFFAIRS BY MAIL AT 1625 NORTH MARKET BLVD., SACRAMENTO,
                CA 95834
              </p>
            </div>
            <h3 class="text-xl pt-8">XVI. DIGITAL MILLENNIUM COPYRIGHT ACT</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                IF YOU BELIEVE THAT MATERIALS OR CONTENT AVAILABLE ON ANY
                PLATFORM WEBSITE INFRINGES ANY COPYRIGHT YOU OWN, YOU OR YOUR
                AGENT MAY SEND PLATFORM A NOTICE REQUESTING THAT PLATFORM REMOVE
                THE MATERIALS OR CONTENT FROM THE PLATFORM WEBSITE. IF YOU
                BELIEVE THAT SOMEONE HAS WRONGLY FILED A NOTICE OF COPYRIGHT
                INFRINGEMENT AGAINST YOU, YOU MAY SEND PLATFORM A
                COUNTER-NOTICE. NOTICES AND COUNTER-NOTICES SHOULD BE SENT TO
                PLATFORM APPLICATION, INC., ATTENTION LEGAL DEPARTMENT, AT 340
                ROYAL POINCIANA WAY, STE.317-316, PALM BEACH, FLORIDA 33480, OR
                BY E-MAIL TO SUPPORT[A]PLATFORMAREA.COM.
              </p>
            </div>
            <h3 class="text-xl pt-8">
              XVII. ARBITRATION, GOVERNING LAW, AND ATTORNEYS’ FEES.
            </h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                A.ARBITRATION. ANY CLAIM OR GRIEVANCE OF ANY KIND, NATURE OR
                DESCRIPTION THAT YOU HAVE AGAINST PLATFORM APPLICATION, INC.
                INCLUDING, BUT NOT LIMITED TO, ECONOMIC LOSSES, PERSONAL INJURY,
                OR PROPERTY DAMAGE, SHALL BE RESOLVED EXCLUSIVELY IN BINDING
                ARBITRATION IN PALM BEACH COUNTY, FLORIDA. YOU AGREE NOT TO FILE
                SUIT AGAINST PLATFORM APPLICATION, INC. OR ANY OF ITS
                AFFILIATES, SUBSIDIARIES, OFFICERS, DIRECTORS, EMPLOYEES,
                SUCCESSORS, OR ASSIGNS. THE ARBITRATION WILL TAKE PLACE BEFORE A
                NEUTRAL ARBITRATOR (HEREAFTER, “ARBITRATOR”) AGREED UPON BY YOU
                AND PLATFORM APPLICATION, INC. IN THE EVENT THAT YOU AND
                PLATFORM APPLICATION, INC. ARE UNABLE TO REACH AGREEMENT ON AN
                ARBITRATOR, YOU AND PLATFORM APPLICATION, INC. WILL EACH SELECT
                AN ARBITRATOR, AND THE TWO OF THEM WILL SELECT THE ARBITRATOR,
                WHO MUST BE A RESIDENT OF PALM BEACH COUNTY, FLORIDA. THE
                ARBITRATORS SELECTED BY YOU AND PLATFORM APPLICATION, INC. WILL
                HAVE NO FURTHER INVOLVEMENT IN THE ARBITRATION. THE ARBITRATOR
                WILL DETERMINE THE RULES GOVERNING ARBITRATION. THE DECISION OF
                THE ARBITRATOR WILL BE FINAL AND BINDING ON YOU AND PLATFORM
                APPLICATION, INC. AND MAY BE REDUCED TO A JUDGMENT IN ANY COURT
                OF COMPETENT JURISDICTION. THIS AGREEMENT TO ARBITRATE SURVIVES
                ANY TERMINATION OR EXPIRATION OF THE AGREEMENT.
                <br />B.GOVERNING LAW. THIS AGREEMENT SHALL BE GOVERNED,
                CONSTRUED, AND INTERPRETED IN ACCORDANCE WITH THE LAWS OF THE
                STATE OF FLORIDA WITHOUT REGARD TO ANY CHOICE OF LAW PROVISIONS.
                <br />C.WAIVER OF CLASS ACTION CLAIMS. YOU UNDERSTAND AND AGREE
                THAT YOU WILL NOT HAVE THE RIGHT TO PARTICIPATE IN A
                REPRESENTATIVE CAPACITY OR AS A MEMBER OF ANY CLASS OF CLAIMANTS
                PERTAINING TO ANY CLAIMS THAT MAY ARISE UNDER, OR BE IN ANY WAY
                RELATED TO, THIS AGREEMENT. THERE IS NO RIGHT OR AUTHORITY FOR
                ANY CLAIM YOU HAVE AGAINST PLATFORM APPLICATION, INC. TO BE
                BROUGHT ON A CLASS ACTION BASIS OR ON ANY BASIS INVOLVING CLAIMS
                BROUGHT IN A PURPORTED REPRESENTATIVE CAPACITY ON BEHALF OF THE
                GENERAL PUBLIC, OR ON BEHALF OF OTHER PERSONS OR ENTITIES
                SIMILARLY SITUATED. CLAIMS BROUGHT AGAINST PLATFORM APPLICATION,
                INC. MAY NOT BE JOINED OR CONSOLIDATED WITH CLAIMS BROUGHT BY
                ANYONE ELSE. <br />D.LIMITATIONS PERIOD. ANY CLAIM BROUGHT IN
                ARBITRATION MUST BE BROUGHT WITHIN THE TIME PERIOD SET FORTH IN
                ANY STATUTE OF LIMITATIONS THAT, BUT FOR THIS AGREEMENT TO
                ARBITRATE, WOULD APPLY TO THE CLAIMS ASSERTED IN ANY ARBITRATION
                PROCEEDING. <br />E.INJUNCTIVE RELIEF. NOTHING IN THIS AGREEMENT
                PREVENTS PLATFORM APPLICATION, INC. FROM APPLYING TO AND
                OBTAINING FROM ANY COURT HAVING JURISDICTION A TEMPORARY
                INJUNCTION, PRELIMINARY INJUNCTION, PERMANENT INJUNCTION, OR
                OTHER RELIEF AVAILABLE TO PROTECT PLATFORM APPLICATION, INCS’
                RIGHTS PRIOR TO, DURING, OR FOLLOWING ANY ARBITRATION
                PROCEEDING. <br />F.ATTORNEYS’ FEES. YOU AGREE THAT IN THE EVENT
                OF ANY ARBITRATION OR LITIGATION, EACH PARTY WILL EACH BEAR ITS
                OWN COSTS AND ATTORNEYS’ FEES, REGARDLESS OF WHO IS DEEMED THE
                PREVAILING PARTY. THE FOREGOING NOTWITHSTANDING, IF EITHER YOU
                OR PLATFORM APPLICATION, INC. COMMENCES AN ACTION IN A COURT OF
                LAW OR EQUITY AND THE RESPONDING PARTY SUCCESSFULLY MOVES SUCH
                COURT TO COMPEL ARBITRATION, THE PARTY WHO MOVED FOR THE ORDER
                COMPELLING ARBITRATION SHALL BE ENTITLED TO RECOVER ITS
                REASONABLE COSTS AND ATTORNEYS’ FEES INCURRED ON THE MOTION TO
                COMPEL FROM THE OTHER PARTY.
              </p>
            </div>
            <h3 class="text-xl pt-8">XVIII. CHANGES TO TERMS</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                PLATFORM APPLICATION, INC. RESERVES THE RIGHT TO CHANGE THESE
                TERMS, IN WHOLE OR IN PART, FROM TIME TO TIME AT PLATFORM
                APPLICATION, INC.’S SOLE AND ABSOLUTE DISCRETION, AND TO PROVIDE
                YOU WITH NOTICE OF SUCH CHANGE BY ANY REASONABLE MEANS,
                INCLUDING WITHOUT LIMITATION POSTING REVISED TERMS
                HTTPS://WWW.PLATFORMAREA.COM/TERMS. BY YOUR CONTINUED USE OF
                PLATFORMS’ SERVICES, AND UNLESS YOU TERMINATE THIS AGREEMENT AS
                PROVIDED HEREIN, YOU MANIFEST YOUR AGREEMENT TO ANY SUBSEQUENT
                CHANGES TO THE TERMS.
              </p>
            </div>
            <h3 class="text-xl pt-8">XIX. SEVERABILITY</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                IF ANY TERM SET FORTH HEREIN IS DEEMED UNENFORCEABLE UNDER ANY
                APPLICABLE LAW, THE REMAINING TERMS SHALL REMAIN IN FULL FORCE
                AND EFFECT AND THESE TERMS SHALL BE READ, COLLECTIVELY, AS IF
                THE UNENFORCEABLE TERM(S) WERE OMITTED.
              </p>
            </div>
            <h3 class="text-xl pt-8">XX. WAIVER.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                NO WAIVER BY PLATFORM APPLICATION, INC. OF ANY BREACH OR DEFAULT
                OF THESE TERMS WILL BE DEEMED TO BE A WAIVER OF ANY PRECEDING OR
                SUBSEQUENT BREACH OR DEFAULT.
              </p>
            </div>
            <h3 class="text-xl pt-8">XXI. HEADING.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3">
              <p>
                ANY HEADING, CAPTION OR SECTION TITLE CONTAINED HEREIN IS
                INSERTED ONLY AS A MATTER OF CONVENIENCE, AND IN NO WAY DEFINES
                OR EXPLAINS ANY SECTION OR PROVISION HEREOF.
              </p>
            </div>
            <h3 class="text-xl pt-8">XXII. NOTICE.</h3>
            <div class="text-gray-600 grid gap-y-3 pt-3 pb-36">
              <p>
                ANY NOTICE REQUIRED TO BE GIVEN TO PLATFORM APPLICATION, INC.
                UNDER OR RELATED TO THESE TERMS MUST BE IN WRITING, ADDRESSED AS
                FOLLOWS: <br />PLATFORM APPLICATION, INC. <br />340 ROYAL
                POINCIANA WAY-STE 317-316 <br />PALM BEACH, FL 33480
              </p>
              <br />
              <p>
                GENERAL SUPPORT AND INQUIRIES: INFO[A]PLATFORMAREA.COM.
                <br />AFFILIATES: AFFILIATES[A]PLATFORMAREA.COM <br />NOTICES TO
                YOU MAY BE MADE BY POSTING A NOTICE (OR A LINK TO A NOTICE) ON
                HTTPS://WWW.PLATFORMAREA.COM/TERMS, BY E-MAIL, OR BY REGULAR
                MAIL, AT PLATFORM APPLICATION, INC.’S DISCRETION. <br />
                <br />JY GALLO <br />FOUNDER OF PLATFORMAREA.COM
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';

export default {
  name: 'PrivacyPage',
  layout: DefaultLayout
};
</script>

<script setup>
import { computed } from 'vue';

const backgroundImageStyleMain = computed(() => {
  const imagePath = '../../../../media/images/download-platforma-hero-bg.svg';
  return {
    '--before-background-image': `url(${imagePath})`
  };
});
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-40%) translateX(0%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}
</style>
